export default __webpack_public_path__ + "static/starCrmImage-ded202cc72ff2e384f95f28e24c07832.webp";